import React, { FC, useState } from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import {
  Dialog as UIFoundationsDialog,
  Text as UIFoundationsText,
  ServiceHighlights as UIFoundationsServiceHighlights,
  getAttributes,
  DialogMaxWidthSizes
} from '@dcxwam/dcx-wam-ui-foundations'
import { EditableComponentPropsType } from '../../../../utils/prop-types'
import RichUSPListEditConfig from './RichUSPListEditConfig'
import { RichUSPListItems, RichUSPListProps } from './types'
import withComponentRefresh from '../../../../utils/aem/editor/withComponentRefresh'

const RichUSPList: FC<EditableComponentPropsType<RichUSPListProps>> = withComponentRefresh(({
  ...props
}) => {
  const { dialogCloseAriaLabel, background, items, ...rest } = props.model
  const editableProps = { ...props, model: { ...rest } }

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
  const [dialogTitle, setDialogTitle] = useState<string>('')
  const [dialogDescription, setDialogDescription] = useState<string>('')

  const closeDialog = () => {
    setIsDialogOpen(false)
  }

  const openDialog = (
    title: string | undefined,
    description: string | undefined
  ) => {
    setDialogTitle(title || '')
    setDialogDescription(description || '')
    setIsDialogOpen(true)
  }

  const listItems = items?.map((item: RichUSPListItems) => {
    const shouldShowInfoIcon = Boolean(
      item?.dialogTitle || item?.dialogDescription
    )
    return {
      image: {
        alt: item?.imageAlt,
        src: item?.imagePath
      },
      content: item?.text,
      iconAreaLabel: item?.buttonAriaLabel,
      showInfoIcon: shouldShowInfoIcon,
      onClick: () => {
        if (shouldShowInfoIcon) {
          openDialog(item?.dialogTitle, item?.dialogDescription)
        }
      },
      ...getAttributes(item)
    }
  })

  const richUSPConfig = {
    listItems,
    background
  }

  const dialogConfig = {
    isOpen: isDialogOpen,
    dismissible: true,
    title: dialogTitle,
    onClose: closeDialog,
    closeAriaLabel: dialogCloseAriaLabel,
    maxWidth: DialogMaxWidthSizes.SM
  }

  const dialogTextConfig = {
    content: dialogDescription,
    isHtml: true
  }

  return (
    <EditableComponent {...editableProps}>
      {RichUSPListEditConfig?.isEmpty(props?.model) ? (
        RichUSPListEditConfig?.emptyLabel
      ) : (
        <>
          <UIFoundationsServiceHighlights {...richUSPConfig} />
          <UIFoundationsDialog {...dialogConfig}>
            <UIFoundationsText {...dialogTextConfig} />
          </UIFoundationsDialog>
        </>
      )}
    </EditableComponent>
  )
})

export default RichUSPList
